export default "__VITE_ASSET__BIGCDpiv__"